module.exports = __webpack_public_path__ + "static/media/trial3_4.757a4a3a.png";